import { useState } from "react";
import { Stack, Group, Title, Text, ThemeIcon, Tabs } from "@mantine/core";
import {
  IconFileInvoice,
  IconReportAnalytics,
  IconApi,
} from "@tabler/icons-react";
import { SampleDataTab } from "./SampleDataTab";
import { InvoiceApiTab } from "./InvoiceApiTab";

/**
 * Top-level page for the gr-invoice-automation module. Wraps two tabs:
 *   - Sample Data Generation: pull SAP GRs, generate Duvo-ready JSON, push to
 *     sandbox.
 *   - Invoice API: manual tester for the inbound webhooks + list of every AP
 *     invoice Duvo has posted.
 */
export default function GrInvoiceAutomationPage() {
  const [tab, setTab] = useState("sample");

  return (
    <Stack gap="lg">
      <Group justify="space-between" wrap="wrap" align="flex-start">
        <Group gap="md">
          <ThemeIcon size={42} radius="md" variant="light">
            <IconFileInvoice size={24} />
          </ThemeIcon>
          <div>
            <Title order={2}>GR Invoice Automation</Title>
            <Text c="dimmed">
              Generate Duvo-ready sample data from SAP GRs and receive AP
              invoices back from Duvo.
            </Text>
          </div>
        </Group>
      </Group>

      <Tabs value={tab} onChange={setTab} variant="default" radius="md">
        <Tabs.List>
          <Tabs.Tab
            value="sample"
            leftSection={<IconReportAnalytics size={16} />}
          >
            Sample Data Generation
          </Tabs.Tab>
          <Tabs.Tab value="api" leftSection={<IconApi size={16} />}>
            Invoice API
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="sample" pt="md">
          <SampleDataTab />
        </Tabs.Panel>
        <Tabs.Panel value="api" pt="md">
          <InvoiceApiTab />
        </Tabs.Panel>
      </Tabs>
    </Stack>
  );
}
